import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePatient } from "../../contexts";
// import SendForVital from "../modals/SendForVital";
// import SendForVital from "../modals/SendForVital";
import Cookies from "js-cookie";
import { RiEdit2Fill, RiEditBoxFill, RiEditCircleFill, RiFileEditLine, RiPencilFill, RiPencilLine, RiPulseLine } from "react-icons/ri";
import { AiOutlineEdit, AiOutlinePlus } from "react-icons/ai";
import WalkInModal from "../modals/WalkInModal";
import PayWalkInModal from "../modals/PayWalkInModal";
import PayWalkInLabRequest from "../modals/PayWalkInLabRequest";
import QueueWalkInModal from "../modals/QueueWalkIn";
import Spinner from "../UI/Spinner";
import TableSkeleton from "../tables/TableSkeleton";

function WalkInTable({ data, currentPage, itemsPerPage, loading, renderTabContent }) {
  const { setPatientId, setPatientName, setPatientPage, setHmoId, setPatientInfo, nurseRoles, setHmoDetails } = usePatient();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [patientData, setData] = useState([]);

  let navigate = useNavigate();

  const closeModal = () => {
    setIsModalOpen(false);

  };

  const handleEdit = (data) => {
    setPatientInfo(data);
    navigate("/patient-details")
  }

  const selectRecord = (id, data) => {
    setIsModalOpen(true);
    setPatientName(`${data.firstName} ${data.lastName}`);
    setPatientInfo(data);
    setPatientId(id);
    Cookies.set('patientId', id);
    Cookies.set('patientInfo', JSON.stringify(data));
    Cookies.set('patientName', `${data.firstName} ${data.lastName}`);
  };


  const addToQueue = (data) => {
    console.log(data)
    setData(data);
    setIsModalOpen(true);
  }


  const continueUpdate = (data) => {
    setPatientInfo(data);
  };

  const isMobile = window.innerWidth < 768;

  if (isMobile) {
    return (
      <div className="w-100">
        <div className="flex flex-col gap-12 m-t-20">
          {loading ? (
            <TableSkeleton primary={5} secondary={4} />
          ) : (
            Array.isArray(data) && data?.map((row) => (
              <div key={row?.patientId || row?.id} className="card shadow-sm m-b-20" style={{ borderRadius: '8px', border: '1px solid #e0e0e0', overflow: 'hidden' }} onClick={() => continueUpdate(row)}>
                <div className="flex flex-h-between flex-v-center" style={{ padding: '15px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #eee' }}>
                  <h4 className="m-0" style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>{row?.firstName} {row?.lastName} {row?.isReferred ? <span className="add-note" style={{fontSize: '10px'}}>(Referred)</span> : ''}</h4>
                  <span style={{ fontSize: '12px', color: '#666' }}>{row?.patientRef}</span>
                </div>
                <div style={{ padding: '15px' }}>
                  <div className="m-b-5" style={{ fontSize: '14px' }}><strong>Email:</strong> {row?.email}</div>
                  <div className="m-b-5" style={{ fontSize: '14px' }}><strong>Mobile:</strong> {row?.phoneNumber}</div>
                  <div className="m-b-5" style={{ fontSize: '14px' }}><strong>Gender:</strong> {row?.gender}</div>
                </div>
                <div className="flex flex-h-end flex-v-center" style={{ padding: '10px 15px', backgroundColor: '#f8f9fa', borderTop: '1px solid #eee', gap: '10px' }}>
                    <button onClick={(e) => { e.stopPropagation(); addToQueue(row); }} className="rounded-btn m-r-5" style={{padding: '6px 12px', fontSize: '12px'}}>
                      <div className="flex flex-v-center">
                        <span>Order</span>
                        <AiOutlinePlus size={14} className="m-l-5 pointer" />
                      </div>
                    </button>
                    <button onClick={(e) => { e.stopPropagation(); handleEdit(row); }} className="rounded-btn" style={{padding: '6px 12px', fontSize: '12px'}}>
                      <div className=" flex flex-v-center">
                        <span>Update</span>
                        <RiPencilLine size={14} className="hover-icon m-l-5 pointer" />
                      </div>
                    </button>
                </div>
              </div>
            ))
          )}
        </div>
        {isModalOpen && <QueueWalkInModal closeModal={closeModal} patientData={patientData} />}
      </div>
    );
  }

  return (
    <div className="w-100">
      <div className="w-100 none-flex-item m-t-40">
        {/* <h2>ALL WALK-IN PATIENTS</h2> */}
        <table className="bordered-table">
          <thead className="border-top-none">
            <tr className="border-top-none">
              <th className="center-text">Lab Id</th>
              {/* <th className="center-text">Patient Id</th> */}
              <th className="center-text">First Name</th>
              <th className="center-text">Last Name</th>
              <th className="center-text">Email</th>
              {/* <th className="center-text">Username</th> */}
              <th className="center-text">Mobile Number</th>
              <th className="center-text">Gender</th>
              {/* <th className="center-text">Created On</th> */}
              <th className="center-text">Action</th>
              <>
                {nurseRoles?.includes('checkin') &&
                  <th className="center-text"></th>
                }
              </>
            </tr>
          </thead>

          {loading ? (
            <TableSkeleton primary={10} secondary={7} /> 
          ) : <tbody className="white-bg view-det-pane">
            {Array.isArray(data) &&
              data?.map((row, index) => (
                <tr className=" " onClick={() => continueUpdate(row)} key={row?.patientId || row?.id}>
                  <td>{row?.patientRef}</td>
                  {/* <td>{row?.patientRef}</td> */}
                  <td>
                    <div>
                      {row?.firstName} {row?.isReferred ? <span className="add-note">Referred</span> : ''}
                    </div>
                  </td>
                  <td>{row?.lastName}</td>
                  <td>{row?.email}</td>
                  <td>{row?.phoneNumber}</td>
                  <td>{row?.gender}</td>
                  {/* <td>{new Date(row?.createdAt).toLocaleDateString()}</td> */}
                  <td>
                    <button onClick={() => addToQueue(row)} className="rounded-btn m-r-10">
                      <div className="flex flex-v-center">
                        <span>Place Order</span>
                        <AiOutlinePlus size={15} className="m-l-10 pointer" />
                      </div>
                    </button>
                    <button onClick={() => handleEdit(row)} className="rounded-btn">
                      <div className=" flex flex-v-center">
                        <span>Update Record</span>
                        <RiPencilLine size={15} className="hover-icon m-l-10 pointer" />
                      </div>
                    </button>
                  </td>
                  {/* <>
                    {nurseRoles?.includes('checkin') &&
                      <td><button onClick={(e) => { e.stopPropagation(); selectRecord(row?.patientId || row?.id, row) }} className="submit-btn">Send for vitals</button></td>
                    }
                  </> */}
                </tr>
              ))}
          </tbody>}
        </table>
      </div>

      {isModalOpen &&
        <QueueWalkInModal
          closeModal={closeModal}
          patientData={patientData}
        />
      }
    </div>
  );
}

export default WalkInTable;